import InventoryPage from "./inventoryPage"
export default InventoryPage;